import React from 'react'
import { BonusBuysBanner } from './BonusBuysBanner'
import DeliveryPromotionBanner from './DeliveryCategoriesBanner'
import { getDiscountData } from '../../DiscountPercentage'
import { BANNER_TYPE, BONUS_BUYS_BANNER_TYPE } from './constants'
import { getBannerType } from './getBannerType'

const BannerDiscountSwitcher = ({ productDetails, lang, format }) => {
  const discountData = getDiscountData(productDetails)
  const bannerType = getBannerType({ productDetails, discountData })

  if (bannerType === BANNER_TYPE.DELIVERY) {
    return <DeliveryPromotionBanner productDetails={productDetails} lang={lang} format={format} />
  }
  return Object.values(BONUS_BUYS_BANNER_TYPE).includes(bannerType) ? (
    <BonusBuysBanner
      bannerType={bannerType}
      productDetails={productDetails}
      discountData={discountData}
      format={format}
      lang={lang}
    />
  ) : null
}

export default BannerDiscountSwitcher
